import React from "react";
import { useFormContext } from "react-hook-form";
import RadioCss from "./radioBtn.module.scss";



function Radiobutton(props) {
  const { label, id, name, value } = props;
  const { register } = useFormContext();

  return (
    <>
      {/* <label for={id} className={`${RadioCss.tabclix__label_radio}`}/> */}
        <input
          {...register(`${name}`)}
          className={`${RadioCss.tabclix__radio}`}
          type="radio"
          value={label}
          id={id}
          name={name}
        />
        <span className={`${RadioCss.tabclix__label_radio} w-form-label`} htmlFor="radio" for={id}>
          {label}
        </span>
    </>
  );
}

export default Radiobutton;